import {gql} from "@apollo/client";

const blogPostDetailQuery = gql`
    query blogPostDetailQuery($postId: String) {
        post(id: $postId) {
            id
            title
            body
            coverImages(raw: true)
            created
            readingTime
            numberOfViews
            youtubeVideo
            videoContent {
                id
                status
                type
                url {
                    url
                }
            }
            status
            topic {
                id
                name
            }
            flaggedByUser
            shareUrl
            author {
                id
                firstName
                lastName
                profilePhoto
                university {
                    id
                    name
                    widgetUrl
                }
                degree {
                    id
                    name
                }
                country {
                    id
                    code
                    name
                }
                mentorFields {
                    primaryFlag {
                        code
                    }
                    secondaryFlag {
                        code
                    }
                }
                accountRole
                active
                archived
            }
        }
    }
`;

export default blogPostDetailQuery;
